// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageBroadcasts_overlayWrapper__Q+uVP","viewBox":"ManageBroadcasts_viewBox__wwifM","tablestyle":"ManageBroadcasts_tablestyle__pg4Sj"};